<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-05-07 16:33:22
 * @FilePath: /mrc-ess-fronted/src/Page/EssAdmin/Announcement/newAnnouncement.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-01-18 15:31:13
-->
<template>
  <ContentLayout
    widthClass="max-1000"
    :title="$t('label_essweb_Announcement_form_newTitle')"
    :initData="announcementData"
    @change="(changed) => (isChanged = changed)"
    backgroundClass="white"
    :checkData="[
      'message_title',
      'message_content',
      'send_org_level_uuid',
      'send_end_utc_datetime',
      'send_start_utc_datetime',
    ]"
  >
    <!-- content -->
    <template v-slot:page-main>
      <v-form ref="form" lazy-validation>
        <v-row align="center" justify="start">
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <normalInputTextFiled
              v-model="announcementData.message_title"
              :rules="$GetRules(['_Require_Rules'], [null])"
              maxlength="200"
              :label="
                $t('label_essweb_Announcement_form_announcementTitleLabel')
              "
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <DateTimePicker
              isRequire
              type="datetimerange"
              :value="dateTerminal"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :defaultStartTime="announcementData.send_start_utc_datetime"
              :defaultEndTime="announcementData.send_end_utc_datetime"
              :label="$t('label_essweb_Announcement_form_publicTimeLabel')"
              @change="
                (time, isre) => {
                  dateTerminal = time;
                  if (isre) {
                    announcementData.send_start_utc_datetime = time
                      ? time.split(' - ')[0]
                      : '';
                    announcementData.send_end_utc_datetime = time
                      ? time.split(' - ')[1]
                      : '';
                  }
                }
              "
            />
          </v-col>

          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_Announcement_form_orgLeaveLabel")
            }}</v-sheet>
            <v-combobox
              v-model="announcementData.send_org_level_uuid"
              :items="[]"
              multiple
              item-color="transparent"
              small-chips
              :rules="$GetRules(['_Require_ArrRules'], [null])"
              filled
              dense
              @update:search-input="
                (e) => {
                  search = e;
                }
              "
              single-line
            >
              <template v-slot:selection="data">
                <v-chip
                  v-bind="data.attrs"
                  close
                  class="mx-1 my-1"
                  :input-value="data.selected"
                  v-if="data.index < $selectSetting.maxChips"
                  @click="data.select"
                  @click:close="removeOrg(data.item)"
                >
                  {{ $getCommonLangValue(data.item.org_level_name) }}
                </v-chip>
                <span
                  v-if="data.index === $selectSetting.maxChips"
                  class="text--primary py-2"
                >
                  ...{{
                    announcementData.send_org_level_uuid.length -
                    $selectSetting.maxChips
                  }}{{ $t("label_essweb_selection_moreItemLabel") }}
                </span>
              </template>
              <template v-slot:no-data>
                <noContent v-if="orgData.length == 0" />
                <v-treeview
                  selectable
                  v-else
                  open-all
                  open-on-click
                  selected-color="primary"
                  :search="search"
                  :filter="filter"
                  :items="orgData"
                  item-key="uuid"
                  v-model="announcementData.send_org_level_uuid"
                  return-object
                  item-text="org_level_name"
                  item-children="son_org"
                >
                  <template v-slot:label="{ item }">
                    <span
                      class="text--secondary"
                      v-html="hightLightKeyword(item.org_level_name, search)"
                    ></span>
                  </template>
                </v-treeview>
              </template>
            </v-combobox>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="mb-0 pb-0">
            <v-sheet class="mrc_text_require text--secondary">
              {{ $t("label_essweb_Announcement_form_contentLabel") }}
            </v-sheet>
            <v-textarea
              rows="5"
              no-resize
              maxlength="500"
              v-model="announcementData.message_content"
              dense
              :rules="$GetRules(['_Require_Rules'], [null])"
              counter="500"
              single-line
              filled
            ></v-textarea>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="pt-0 mt-0">
            <v-checkbox
              v-model="announcementData.is_confirm_read"
              :label="$t('label_essweb_Announcement_form_confirmReadLabel')"
              required
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions newBtn @new="toAdd" @cancel="$toBack(isChanged)" />
    </template>
    <!-- actions -->
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "newAnnouncement",
  computed: {
    ...mapGetters(["companyLang", "AppInfo", "defaultLang"]),
    curAppInfo() {
      return this.AppInfo ? JSON.parse(this.AppInfo) : null;
    },
    filter() {
      return (item, search, textKey) =>
        this.$getCommonLangValue(item[textKey]).indexOf(search) > -1;
    },
  },
  data() {
    return {
      search: "",
      dateTerminal: "",
      isChanged: false,
      orgData: [],
      announcementData: {
        message_title: "",
        is_confirm_read: false,
        send_org_level_uuid: [],
        message_content: "",
        send_end_utc_datetime: "",
        send_start_utc_datetime: "",
      },
    };
  },
  mounted() {
    this.getOrgList();
  },
  methods: {
    hightLightKeyword(val, keyword) {
      val = this.$getCommonLangValue(val);
      if (val.indexOf(keyword) !== -1) {
        return val.replace(
          keyword,
          `<font style='background-color:rgba(0,0,0,0.12)'>${keyword}</font>`
        );
      } else {
        return val;
      }
    },
    removeOrg(item) {
      const index = this.announcementData.send_org_level_uuid.indexOf(item);
      if (index >= 0)
        this.announcementData.send_org_level_uuid.splice(index, 1);
    },
    toAdd() {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      let uuids = [];
      const that = this;
      this.announcementData.send_org_level_uuid.map((item) => {
        uuids.push(item.uuid);
      });
      this.$Request({
        method: "POST",
        table: "mrbase_sys_announcement",
        url: "/announcement/add/",
        data: {
          message_title: this.announcementData.message_title,
          message_content: this.announcementData.message_content,
          send_org_level_uuid: uuids.join(","),
          send_start_utc_datetime: this.$getTimeValue(
            this.announcementData.send_start_utc_datetime
          ),
          send_end_utc_datetime: this.$getTimeValue(
            this.announcementData.send_end_utc_datetime
          ),
          is_confirm_read: this.announcementData.is_confirm_read ? 1 : 0,
        },
      }).then((res) => {
        that.$toBack();
      });
    },
    getOrgList: function () {
      const that = this;
      this.$getStaffList({}, true, false).then((res) => {
        if (JSON.stringify(res) == "{}" || !res) {
          that.orgData = [];
        } else {
          that.orgData = [res];
        }
      });
    },
  },
};
</script>
